export default __webpack_public_path__ + "static/media/ic_hop.1947e115.svg";